import { FBPage } from 'components/FbUI/Page/FBPage'
import { Outlet, useLocation } from 'react-router-dom'
import {
  FBPageEyebrow,
  FBPageHeader,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { PiGear } from 'react-icons/pi'
import { PinToHomepageButton } from 'components/QuickAccess/PinToHomepageButton'
import { useRecordVisit } from 'components/QuickAccess/useRecordVisit'
import { PAGE_KEYS } from 'services/homepage'

import { useMemo } from 'react'

const GROUP_TITLES: Record<string, React.ReactNode> = {
  company: 'Company',
  team: 'Team',
  platform: 'Platform',
  data: 'Data',
  notifications: 'Notifications',
  misc: 'Misc Settings',
  automations: 'Automations',
  outreach: 'Outreach',
  'email-integration': 'Email Integration',

  ai: 'AI Agents',
}

export function SettingsLayout() {
  const location = useLocation()

  const group = useMemo(() => {
    const segments = location.pathname.split('/')
    return segments[2] ?? 'team'
  }, [location.pathname])

  const groupTitle = GROUP_TITLES[group] ?? 'Team'

  useRecordVisit({ targetType: 'page', pageKey: PAGE_KEYS.settings })

  return (
    <FBPage
      innerPageClassName="h-full !bg-surface-page"
      containerClassName="!bg-surface-page !shadow-none"
    >
      <FBPageHeader className="!mb-6">
        <FBPageTitleRow>
          <div className="flex flex-col items-start">
            <FBPageEyebrow>
              <PiGear size={14} />
              Settings
            </FBPageEyebrow>
            <FBPageTitle className="!text-fg">{groupTitle}</FBPageTitle>
          </div>
          <PinToHomepageButton
            target={{ targetType: 'page', pageKey: PAGE_KEYS.settings }}
          />
        </FBPageTitleRow>
      </FBPageHeader>

      <div className="flex gap-0 flex-1 min-h-0 h-full">
        <Outlet />
      </div>
    </FBPage>
  )
}
